import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../hooks';
import { sendCourseCreditReminderNotificationToAdmin } from '../../store/V2/CoursesSlice';

const ActionsPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const triggerType = searchParams.get('type');
    const courseId = searchParams.get('courseId');
    const whatsappLink = searchParams.get('whatsappLink');

    if (triggerType === 'emailCreditsReminder' && courseId) {
      dispatch(
        sendCourseCreditReminderNotificationToAdmin({
          courseId,
          sourceName: 'Email',
        })
      );

      searchParams.delete('type');
      searchParams.delete('courseId');

      setSearchParams(searchParams);

      navigate(`${process.env.PUBLIC_URL}/portal/courses/${courseId}`, {
        replace: true,
      });
    } else if (
      triggerType === 'whatsappCreditsReminder' &&
      courseId &&
      whatsappLink
    ) {
      dispatch(
        sendCourseCreditReminderNotificationToAdmin({
          courseId,
          sourceName: 'Whats app',
        })
      );

      searchParams.delete('type');
      searchParams.delete('courseId');
      searchParams.delete('whatsappLink');

      setSearchParams(searchParams);

      window.location.href = whatsappLink;
    }
  }, []);

  return null;
};

export default ActionsPage;
